import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import { get as getTeacherStudents } from 'actions/teacher-students';
import Search from 'modules/list/search-bar';
import { Row } from '@cuemath/comps';

const LinkNav = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
  text-align: center;
  &:hover {
    color: blue;
  }
  &:active {
    color: blue;
  }
`;

const HeadWrapper = styled(Row)`
  width: 100%;
  margin-top: 20px;
  padding-left: 16px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const TableWrapper = styled.div`
  width: 100%;
  padding: auto 20px;
  margin: 20px 0;
`;

const StudentList = ({ actions, teacherStudents }) => {
  let { teacherId } = useParams();

  const [searchStudent, setSearchStudent] = useState('');
  const [studentList, setStudentList] = useState([]);

  useEffect(() => {
    actions.getTeacherStudents(teacherId);
  }, [teacherId]);

  useEffect(() => {
    const teacherStudentList = store.get(teacherStudents, teacherId);
    const { isLoaded, data } = teacherStudentList || {};
    if (teacherStudentList && isLoaded) {
      setStudentList(
        data.filter(student => student.name.toLowerCase().includes(searchStudent)),
      );
    }
  }, [teacherStudents, searchStudent]);

  const studentListColumn = [
    {
      Header: 'Name',
      accessor: 'name',
      Cell: row => {
        return (
          <LinkNav
            target="_blank"
            to={{
              pathname: `/student-form/${row.original.student_id}`,
            }}
          >
            {row.original.name}
          </LinkNav>
        );
      },
    },
    {
      Header: 'Grade',
      accessor: 'grade',
      width: 100,
    },
    {
      Header: 'Student Id',
      accessor: 'student_id',
      width: 330,
    },
    {
      Header: 'Foundation Id',
      accessor: 'foundation_id',
      width: 330,
      Cell: ({ value }) => (value ? value : 'Not Found'),
    },
    {
      Header: 'State',
      accessor: 'state',
      width: 100,
    },
  ];

  return (
    <>
      <HeadWrapper>
        <Search
          type="text"
          placeholder="Search Student..."
          onChange={e => setSearchStudent(e.target.value)}
        />
      </HeadWrapper>
      <TableWrapper>
        <ReactTable
          className="-striped -highlight"
          data={studentList}
          manual
          showPageSizeOptions={false}
          filterable={false}
          sortable={false}
          defaultPageSize={15}
          resizable={true}
          columns={studentListColumn}
          style={{ textAlign: 'center' }}
        />
      </TableWrapper>
    </>
  );
};

export default connect(
  ({ teacherStudents }) => ({
    teacherStudents,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getTeacherStudents,
      },
      dispatch,
    ),
  }),
)(StudentList);
